import orderBy from 'lodash/orderBy';
import keys from 'lodash/keys';
import { ORDER } from '../const';
/**
 * SortCollection decorator - Sorts a property collection by the given iteratee in a given order
 * @param iteratee string | string[] - iteratee, invoked with one argument, each item of the collection
 * @param orders Order | ('asc'|'desc')[] - order for each iteratee, can be 'asc' or 'desc'
  ```
    import { SortCollection } from '@emobg/web-utils';

    @SortCollection('licensePlate', 'desc')
    myCollection
  ```
 */
export function SortCollection(iteratee = '', orders = ORDER.asc) {
    return function (_target, _propertyKey) {
        let value;
        const getter = () => {
            const sorter = iteratee.length ? iteratee : keys(value[0])[0];
            return orderBy(value, sorter, orders);
        };
        const setter = (newValue) => {
            value = newValue;
        };
        Object.defineProperty(_target, _propertyKey, {
            get: getter,
            set: setter,
        });
    };
}
